import { useReportLoadError } from "../../utils/useReportLoadError";

export type ErrorDisplayProps = {
	error: Error | null;
	componentToDisplay?: React.ReactNode;
};

/** @deprecated Use ReportedRetryableLoadError for retryable query failures. */
export const ErrorDisplay = ({ error, componentToDisplay }: ErrorDisplayProps) => {
	useReportLoadError(error);

	return componentToDisplay ? (
		<>{componentToDisplay}</>
	) : (
		<div className="text-gray-700">An error occurred</div>
	);
};
